export default __webpack_public_path__ + "static/Performance-76db7787ad0d5d180da25a788ddd179b.mp4";